import { createContext, useContext, useEffect, useState } from "react";

const CartContext = createContext(null);

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try {
      return JSON.parse(localStorage.getItem("cf_cart")) || [];
    } catch {
      return [];
    }
  });
  const [open, setOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem("cf_cart", JSON.stringify(items));
  }, [items]);

  const add = (p, qty = 1) => {
    const startQty = Math.max(qty, p.min_qty || 1);
    setItems((prev) => {
      const ex = prev.find((i) => i.id === p.id);
      if (ex) return prev.map((i) => (i.id === p.id ? { ...i, quantity: i.quantity + startQty } : i));
      return [...prev, { id: p.id, name: p.name, price: p.price, image: p.image, quantity: startQty, min_qty: p.min_qty || 1, max_qty: p.max_qty || 0 }];
    });
    setOpen(true);
  };

  const remove = (id) => setItems((prev) => prev.filter((i) => i.id !== id));
  const setQty = (id, qty) =>
    setItems((prev) => {
      const it = prev.find((i) => i.id === id);
      if (!it) return prev;
      if (qty <= 0) return prev.filter((i) => i.id !== id);
      const min = it.min_qty || 1;
      const max = it.max_qty || 0;
      let q = qty;
      if (q < min) q = min;
      if (max > 0 && q > max) q = max;
      return prev.map((i) => (i.id === id ? { ...i, quantity: q } : i));
    });
  const clear = () => setItems([]);

  const total = items.reduce((s, i) => s + i.price * i.quantity, 0);
  const count = items.reduce((s, i) => s + i.quantity, 0);

  return (
    <CartContext.Provider value={{ items, add, remove, setQty, clear, total, count, open, setOpen }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
